/**
 * Labstep
 *
 * @module components/ResourceTemplate/Action/Duplicate
 * @desc Button to duplicate a resource template
 */

import { EntityActionDuplicate } from 'labstep-web/components/Entity/Action/Duplicate';
import type React from 'react';
import type { IResourceTemplateActionDuplicateProps } from './types';

export const ResourceTemplateActionDuplicate: React.FC<
  IResourceTemplateActionDuplicateProps
> = ({ resourceTemplate }) => (
  <EntityActionDuplicate
    entity={resourceTemplate}
    body={{ is_template: true }}
  />
);
